import { render, staticRenderFns } from "./subprogram-nba-summary.vue?vue&type=template&id=6705a8a4&scoped=true&"
import script from "./subprogram-nba-summary.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-summary.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-summary.vue?vue&type=style&index=0&id=6705a8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705a8a4",
  null
  
)

export default component.exports